import { useEffect, useRef } from "react";
import { toast } from "./toast";

export function useQueryErrorToast(error: unknown, title: string, id: string): void {
  const last = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (!error) {
      if (last.current) toast.dismiss(id);
      last.current = undefined;
      return;
    }
    const key = `${id}:${title}`;
    if (last.current === key) return;
    last.current = key;
    toast.error(title, { id });
  }, [error, title, id]);
  useEffect(() => () => toast.dismiss(id), [id]);
}
